import { ErrorCode } from '../errorCodeToDisplayText/errorCode'

const SLOT_UNAVAILABLE_ERROR_CODES: string[] = [
  ErrorCode.REQUESTED_TIME_SLOT_UNAVAILABLE,
  ErrorCode.START_DATE_NO_LONGER_AVAILABLE,
  ErrorCode.RESOURCE_RESERVATION_ALREADY_EXISTS,
]

const isSlotUnavailableError = (error: any): boolean => {
  const errorCode = error?.response?.data?.error_code
  return SLOT_UNAVAILABLE_ERROR_CODES.includes(errorCode)
}

export { isSlotUnavailableError, SLOT_UNAVAILABLE_ERROR_CODES }
